/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-chart-axis',
  templateUrl: 'chart-axis.component.html',
  styleUrls: ['chart-axis.component.scss'],
})
export class ChartAxisComponent {
  @Input() labels: string[] = [];
}
